
export default function Footer() {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="bg-gray-900 text-gray-300 py-16">
      <div className="container mx-auto px-6">
        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-12 mb-12">
          <div>
            <div className="flex items-center space-x-2 mb-6">
              <div className="w-10 h-10 bg-gradient-to-br from-blue-600 to-purple-600 rounded-lg flex items-center justify-center">
                <i className="ri-shield-check-line text-white text-xl"></i>
              </div>
              <span className="text-2xl font-bold text-white">SIERRA ROJA</span>
            </div>
            <p className="text-gray-400 leading-relaxed">
              Protecting your digital privacy with advanced VPN technology and world-class security solutions.
            </p>
          </div>

          <div>
            <h4 className="text-white font-bold text-lg mb-4">Company</h4>
            <ul className="space-y-3">
              <li>
                <a href="#about" className="hover:text-blue-400 transition-colors cursor-pointer">About Us</a>
              </li>
              <li>
                <a href="#features" className="hover:text-blue-400 transition-colors cursor-pointer">Features</a>
              </li>
              <li>
                <a href="#contact" className="hover:text-blue-400 transition-colors cursor-pointer">Contact</a>
              </li>
            </ul>
          </div>

          <div>
            <h4 className="text-white font-bold text-lg mb-4">Contact Info</h4>
            <ul className="space-y-3">
              <li className="flex items-start space-x-2">
                <i className="ri-mail-line text-blue-400 mt-1"></i>
                <a href="mailto:info@sierrarojasrl.com" className="hover:text-blue-400 transition-colors cursor-pointer">
                  info@sierrarojasrl.com
                </a>
              </li>
              <li className="flex items-start space-x-2">
                <i className="ri-phone-line text-blue-400 mt-1"></i>
                <a href="tel:+15185394167" className="hover:text-blue-400 transition-colors cursor-pointer">
                  +1 518-539-4167
                </a>
              </li>
              <li className="flex items-start space-x-2">
                <i className="ri-map-pin-line text-blue-400 mt-1"></i>
                <span>AV ITALIA 574, Oberá, Argentina</span>
              </li>
            </ul>
          </div>

          <div>
            <h4 className="text-white font-bold text-lg mb-4">Follow Us</h4>
            <div className="flex space-x-4">
              <a href="#" className="w-10 h-10 bg-gray-800 rounded-lg flex items-center justify-center hover:bg-blue-600 transition-colors cursor-pointer">
                <i className="ri-facebook-fill text-xl"></i>
              </a>
              <a href="#" className="w-10 h-10 bg-gray-800 rounded-lg flex items-center justify-center hover:bg-blue-400 transition-colors cursor-pointer">
                <i className="ri-twitter-fill text-xl"></i>
              </a>
              <a href="#" className="w-10 h-10 bg-gray-800 rounded-lg flex items-center justify-center hover:bg-blue-700 transition-colors cursor-pointer">
                <i className="ri-linkedin-fill text-xl"></i>
              </a>
              <a href="#" className="w-10 h-10 bg-gray-800 rounded-lg flex items-center justify-center hover:bg-pink-600 transition-colors cursor-pointer">
                <i className="ri-instagram-fill text-xl"></i>
              </a>
            </div>
          </div>
        </div>

        <div className="border-t border-gray-800 pt-8">
          <div className="flex flex-col md:flex-row justify-between items-center space-y-4 md:space-y-0">
            <p className="text-gray-400 text-sm">
              © {currentYear} SIERRA ROJA S.R.L. All rights reserved.
            </p>
            <a 
              href="https://readdy.ai/?origin=logo" 
              target="_blank" 
              rel="noopener noreferrer"
              className="text-gray-400 hover:text-blue-400 transition-colors text-sm cursor-pointer"
            >
              Powered by Readdy
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
}
